<template>
  <header
    class="page-header"
    :class="{
      'page-header--compact': size === 'compact',
      'page-header--break-mobile': breakMobile,
    }"
  >
    <Breadcrumb
      v-if="breadcrumbs && breadcrumbs.length"
      :items="breadcrumbs"
      class="page-header__breadcrumbs"
    />
    <div class="page-header__row">
      <div class="page-header__content">
        <h1 class="page-header__title">{{ title }}</h1>
        <p v-if="description" class="page-header__description">{{ description }}</p>
      </div>
      <div class="page-header__actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </header>
</template>

<script>
  import Breadcrumb from '@/components/partials/Breadcrumb.vue';

  export default {
    components: {
      Breadcrumb,
    },

    props: {
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        default: '',
      },
      breadcrumbs: {
        type: Array,
        default: () => [],
      },
      size: {
        type: String,
        default: 'default',
        validator: (v) => ['default', 'compact'].includes(v),
      },
      breakMobile: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  .page-header {
    padding: 20px 0 48px 0;

    &--compact {
      padding-bottom: 0.5rem;
    }

    @include lg-down {
      padding: 12px 0 16px 0;

      &--compact {
        padding-bottom: 0.25rem;
      }
    }

    &__breadcrumbs {
      margin-bottom: 16px;

      @include lg-down {
        margin-bottom: 8px;
      }
    }

    &__row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
    }

    &__content {
      flex: 1;
      min-width: 0;
    }

    &__title {
      font-size: 24px;
      font-weight: 600;
      color: var(--color-text-primary);
      margin-bottom: 8px;

      @include lg-down {
        font-size: 20px;
        margin-bottom: 0;
      }
    }

    &__description {
      font-size: 14px;
      color: var(--color-text-secondary);
      line-height: 1.5;

      @include lg-down {
        display: none;
      }
    }

    &__actions {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    @include lg-down {
      &--break-mobile {
        .page-header__row {
          flex-direction: column;
          align-items: flex-start;
        }

        .page-header__actions {
          flex-wrap: wrap;
        }
      }
    }
  }
</style>
